// extracted by css-extract-rspack-plugin
export default {"root":"root-ZYYMHU","focus":"focus-cKJljx","input":"input-xK3wrp"};